// ページ読み込み時とURLパラメータ変更時に実行する関数
function scrollToAnchor(anchor) {
  if (anchor) {
    // data-anchor属性に一致する要素を探す
    const targetElement = document.querySelector(`[data-anchor="#${anchor}"]`);

    if (targetElement) {
      // ヘッダーの高さを取得
      const headerHeight = document.querySelector("header").offsetHeight;

      // 要素の位置を計算
      const targetPosition =
        targetElement.getBoundingClientRect().top +
        window.scrollY -
        headerHeight;

      // スクロール
      window.scrollTo({ top: targetPosition, behavior: "smooth" });
    }
  }
}

// ページ内のアンカーリンクのクリックイベントを処理
document.addEventListener("click", function (event) {
  // js-anchor-linkクラスを持つ要素またはその子要素がクリックされたかチェック
  const anchorElement = event.target.closest(".js-anchor-link");

  if (anchorElement) {
    event.preventDefault();

    // data-anchor属性から値を取得
    const anchorValue = anchorElement.dataset.anchor;
    if (anchorValue) {
      // #を除去してアンカー値を取得
      const anchor = anchorValue.substring(1);

      // 現在のURLにアンカーを追加（履歴に追加）
      window.history.pushState(null, "", `#${anchor}`);

      // スクロール処理を実行
      scrollToAnchor(anchor);
    }
  }
});

